import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { LoadingController } from '@ionic/angular';
import { User } from 'src/app/classes/user';
import { GlobalService } from '../global/global.service';
import { UtilsService } from '../utils/utils.service';
import { Ecorecolector } from 'src/app/classes/ecorecolector';
import { Actividad } from 'src/app/classes/actividad';
import { Direccion } from 'src/app/classes/direccion';
import { Envio } from 'src/app/classes/envio';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(
    private db: AngularFirestore,
    private auth:AngularFireAuth,
    private loadingController: LoadingController,
    private globalSrv: GlobalService,
    private utils:UtilsService,
  ) { }


///GETTERS

verificarUser() {
  return new Promise(resolve=>{
  this.auth.user.subscribe(res=>{
      if(!res){
        resolve(false);
      }else{
        this.db.collection("users").doc(res.uid).get().toPromise().then((user)=>{
          if(user.exists){
              this.globalSrv.uid=res.uid;
              resolve(true);
          }else{
            resolve(false);
          }
        });
      }
    }
  )
  });
}

getBarrios(){
  return this.db.collection("barrios").valueChanges();
}

getCurrentUser(uid){
  return this.db.collection("users").doc(uid).valueChanges();   
}

getUserPromise(uid){
  return this.db.collection("users").doc(uid).get();
}
getClientes(){
  return this.db.collection("users", ref=>ref.where("role", "==", "buyer")).valueChanges();
}
getusers(){
  return this.db.collection("users").get();
}
getEcorecolectores(){
  return this.db.collection("ecorecolectores", ref=>ref.where("approved", "==", true)).get();
}

getOldUSer(email){
  return new Promise(resolve=>{
    this.db.collection("users_viejos").doc(email).get().forEach(a=>{
      resolve(a.data());
    });
  })
  
}
getActividadLimit(uid){
  return this.db.collection("users").doc(uid).collection("actividad", ref=>ref.orderBy("id", "desc").limit(5)).valueChanges();
}
getActividad(uid){
  return this.db.collection("users").doc(uid).collection("actividad", ref=>ref.orderBy("id", "desc")).valueChanges();
}
getNovedades(){
  return this.db.collection("novedades", ref=>ref.where("destinatarios", "==", "users")).valueChanges();
}
////SETTERS
registerUser(user: User){
  return this.db.collection("users").doc(user.uid).set(Object.assign({}, user));
}
registerEcoRecolector(ecorecolector: Ecorecolector){
  return this.db.collection("ecorecolectores").doc(ecorecolector.uid).set(Object.assign({}, ecorecolector));
}
// setActividasd(uid, actividad:Actividad){
//   return this.db.collection("users").doc(uid).collection("actividad").doc(actividad.id).set(Object.assign({}, actividad));
// }
setEnvios(envio:Envio){
  return this.db.collection("envios").doc(envio.id).set(Object.assign({}, envio));
}
////UPDATES
updateReciclables(uid, reciclables) {
  let response = this.db.collection("users").doc(uid).update({reciclables:reciclables});
  return response;
}
updateDireccion(direccion:Direccion, uid:string) {
  let response = this.db.collection("users").doc(uid).update({direccion:direccion});
  return response;
}
editProfilePhoto(photoURL){
  return this.db.collection("users").doc(localStorage.getItem("uid")).update({photo:photoURL});
}

updateUser(user: User) {
  let response = this.db.collection("users").doc(user.uid).update(user);
  return response;
}
//////AUTH/////

registerUserAuth(email:string, password: string) {
  return new Promise(resolve=>{
    this.auth.createUserWithEmailAndPassword(email, password).then(res=>{
      console.log(res.user.uid);
      resolve(res.user.uid);
    }).catch(err=>{
      this.loadingController.dismiss();
      let mensaje=this.utils.traductor(err.message);
      this.utils.presentSimpleAlert(mensaje,"","","Ok");
    });
  });
}
 
async loginUser(email:string, password: string) {
  let response: any = await this.auth.signInWithEmailAndPassword(email, password).catch(err=>{
    this.loadingController.dismiss();
    console.log(err);
    let mensaje=this.utils.traductor(err.message);
    this.utils.presentSimpleAlert(mensaje,"","","Ok");
  });
  localStorage.clear();
  return response;
}

loggOut(){
  this.globalSrv.role="";
  this.globalSrv.uid="";
  return this.auth.signOut();
}

forgotPassword(email) {
  return this.auth.sendPasswordResetEmail(email);
}
}
